export default "__VITE_ASSET__b3e4357e__"